export default __webpack_public_path__ + "57a8e0b82d741e99b5f0d9eaccbd7e03.png";